import { Component } from '@angular/core';

@Component({
  selector: 'vs-code',
  imports: [],
  templateUrl: './code.html',
  styleUrl: './code.scss',
})
export class Code {

}
